export default __webpack_public_path__ + "static/media/business-advisory-1.d0ef65d1.svg";